// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectAlgorithmMessageBase } from './DirectAlgorithmMessageBase';
import { Message } from '../Message';
export class DirectAlgorithmsAvailableMessage extends DirectAlgorithmMessageBase {
    constructor() {
        super(Message.CODE_PFIX_ALGORITHMS_AVAILABLE_MESSAGE);
        // AlgorithmId = -1;           // 694 - creating in DirectAlgorithmMessageBase
        // AlgorithmName = null;       // 696 - creating in DirectAlgorithmMessageBase
        this.AlgorithmType = null; // 695 (int) 0 - HIGH_LOW, 1 - GAINERS_LOSERS, 3 - TOP_VOLUME
        this.AlgorithmStatus = null; // 697 (int) 0 - RUNNING, 1 - STOPPED, 2 - INACTIVE
        this.AlgorithmContainerType = -1; // 852 (int)  0 - NONE, 1 - COUNTRY, 2 - CUSTOM
        this.AlgorithmFilterName = null; // 853 (String) - если в 852=2, имя кастомного фильтра для фильтра в панели(Investing).
        this.InstrumentGroupIDs = null; // 797 - список инструмент групп для фильтра в панели(.Net\MAC). Приходит только для  695 =  0 - HIGH_LOW
        this.RouteIDs = null; // 678, список info routes для фильтра в панели (.Net\MAC). Приходит только для  695 =  0 - HIGH_LOW
        this.CountryId = null; // 725 (int) - если в 852=1, страна для которой создан алгоритм для фильтра в панели(Investing).
        this.AvailableRanges = []; // data from ALGORITHM_HISTORICAL_GAINER_LOSER_TIME_RANGE_GROUP
    }
}
